//@ts-nocheck
import { combineReducers } from 'redux';
import cases from './cases';
import { connectRouter } from 'connected-react-router';

const reducers: CMx.HistoricalReducer = (history: History) => {
  return combineReducers({
    cases,
    router: connectRouter(history)
  });
};

export default reducers;
